export const LabelShape = Object.freeze({
    Circular: 'circular',
    Rectangular: 'rectangular',
});
